/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from 'react';
import { URL_BKI } from "../../constants/URL";
//send data from child component to father component
export default function ReqEncrypt({dataJSON, missatge}) {
    const [, setData] = React.useState([]);
    
    const getData = async () => {
        
        const requestOptions = {
            method: 'POST',
            mode:'cors',
            headers:{   'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                    },
            body : JSON.stringify({encryptMsg : missatge}),

        }
    
        await fetch(URL_BKI.ENCRYPT_URL, requestOptions)
        .then(function (response) {
            return response.json();
        })
        .then(function (myJson) {
            setData(myJson);
            dataJSON(myJson);
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
    };

    React.useEffect(() => {
        getData();
    }, []);
    
    return (
        <div></div>
    );
    }